import {createRouter, createWebHistory} from 'vue-router';

const routes = [
  {
    path: '/',
    name: 'index',
    component: () => import('@/views/index/index.vue'),
    children: [
      {
        path: '',
        redirect: '/home'
      },
      {
        path: 'home',
        name: 'home',
        component: () => import('@/views/home/index.vue'),
      },
      {
        path: 'toys',
        name: 'toys',
        component: () => import('@/views/toys/index.vue'),
      },
      {
        path: 'ai-core',
        name: 'ai-core',
        component: () => import('@/views/ai-core/index.vue'),
      },
      {
        path: 'cooperation',
        name: 'cooperation',
        component: () => import('@/views/cooperation/index.vue'),
      },
      {
        path: 'shop',
        name: 'shop',
        component: () => import('@/views/shop/index.vue'),
      },
      {
        path: 'overseas',
        name: 'overseas',
        component: () => import('@/views/overseas/index.vue'),
      },
      {
        path: 'contact',
        name: 'contact',
        component: () => import('@/views/contact/index.vue'),
      },
      {
        path: 'service',
        name: 'service',
        component: () => import('@/views/service/index.vue'),
      },
      {
        path: 'responsibility',
        name: 'responsibility',
        component: () => import('@/views/responsibility/index.vue'),
      }
    ]
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return {
        top: 0,
        behavior: 'smooth'
      };
    }
  }
});

export default router;
